'use client';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { Accordion } from '@s7/ui';
import { NavigationCategoryTitle } from './NavigationCategory/NavigationCategoryTitle.js';
import { CategoryLinks } from './NavigationCategory/NavigationCategoryLinks.js';

const FooterNavigationMobile = (props)=>{
    const { categories } = props;
    return /*#__PURE__*/ jsx(Accordion, {
        children: categories.map(({ id, title, link, items })=>/*#__PURE__*/ jsxs(Accordion.Item, {
                value: String(id),
                children: [
                    /*#__PURE__*/ jsx(Accordion.Item.Control, {
                        children: /*#__PURE__*/ jsx(NavigationCategoryTitle, {
                            link: link,
                            title: title
                        })
                    }),
                    items && items.length && /*#__PURE__*/ jsx(Accordion.Item.Panel, {
                        children: /*#__PURE__*/ jsx(CategoryLinks, {
                            items: items
                        })
                    })
                ]
            }, id))
    });
};

export { FooterNavigationMobile };
//# sourceMappingURL=FooterNavigationMobile.js.map
